import { useEffect } from 'react';
import useSWR from 'swr';
import { createClient } from '@/lib/supabase/client';
import { User } from '@supabase/supabase-js';

export function useUser() {
  const supabase = createClient();
  
  // Use SWR to fetch and cache user data
  const { data: user, error, isLoading, mutate } = useSWR<User | null>(
    'supabase-user',
    async () => {
      const { data: { user } } = await supabase.auth.getUser();
      return user;
    },
  );

  // Listen for auth state changes and update SWR cache
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        // Update the SWR cache with the new user
        mutate(session?.user ?? null, false);
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [mutate, supabase]);

  return {
    user,
    error,
    isLoading,
    mutate
  };
} 